module.exports = __webpack_public_path__ + "static/trees-a8e66b090f709acd1fd5bc617c130948.png";